(function () {
    'use strict';

    angular
        .module('app')
        .controller('systemlog', systemlog);

    systemlog.$inject = ['errorService', '$mdDialog'];

    function systemlog(errorService, $mdDialog) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'systemlog';
        activate();

        vm.hide = function () {
            $mdDialog.hide();
        }

        vm.errorService = errorService;

        vm.clearLocal = function () {
            errorService.errors = [];
        }

        function activate() {


        }
    }
})();
